export default __webpack_public_path__ + "static/our-words-1-c127f0d239b1d5963f5eedfde578b201.jpg";